module.exports = {"220821100":"镇赉镇","220821101":"坦途镇","220821102":"东屏镇","220821103":"大屯镇","220821104":"沿江镇","220821105":"五棵树镇","220821106":"黑鱼泡镇","220821200":"哈吐气蒙古族乡","220821201":"莫莫格蒙古族乡","220821202":"建平乡","220821203":"嘎什根乡","220821400":"四方坨子农场","220821402":"良种繁育场","220821403":"九龙山马场","220821406":"国营渔场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220821.json
// module id = 748
// module chunks = 0